import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e1e88660"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1e88660')) {
      api.createRecord('e1e88660', component.options)
    } else {
      api.reload('e1e88660', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e1e88660", function () {
      api.rerender('e1e88660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/templatemessage/index.vue"
export default component.exports